import { render, staticRenderFns } from "./PersonalProfile.vue?vue&type=template&id=3abe11d4&scoped=true&"
import script from "./PersonalProfile.vue?vue&type=script&lang=js&"
export * from "./PersonalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe11d4",
  null
  
)

export default component.exports